// extracted by mini-css-extract-plugin
export default {"container":"Mq-z","heading":"Nq-z","text":"Oq-z","info":"Pq-z","link":"Qq-z","fullMaxWidth":"Rq-z"};